import LoadingCircle from '../LoadingCircle/LoadingCircle';
import styles from './Blocked.module.scss';

const Blocked = () => {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <span> Please wait...</span>
        <LoadingCircle />
      </div>
    </div>
  );
};

export default Blocked;
